/**
 * Pomocné metody pro práci s flagy
 */
export class FlagUtils {
    /**
     * Zkonvertuje hodnotu z flagu na hodnotu z css
     * @param color Hodnota flagu
     * @returns Hodnota css stylu
     */
    public static flagToCss(color: string): string {
        if (!color)
            return "";

        return (color[0] === "f" ? color.substring(1) : color).toLowerCase();
    }
}
